<template>
  <div class="grid grid-cols-6 gap-6">
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="banco" class="block text-sm font-medium text-gray-700">Banco</label>
      <input type="text" id="banco" :value="loadData.nombre_banco"
             @change="(newNombreBanco)=>$emit('updateValues', {'nombre_banco': newNombreBanco.target.value})"
             class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
  </div>
</template>

<script>
export default {
  name: 'BancosCrearActualizarComponent',
  props: ['loadData'],
  emits: ["updateValues"],
}
</script>